import React from 'react';
import AnalyticsRecruitment from './AnalyticsRecruitment/AnalyticsRecruitment';

const Recruitment = ({ isRTL = false, companyUID = '', analyticsActorId = 'system' }) => (
  <AnalyticsRecruitment isRTL={isRTL} companyUID={companyUID} analyticsActorId={analyticsActorId} />
);

export default Recruitment;
